<template>
    <div v-if="post">
        <!--DEBUT Description-->
        <div v-if="post.texte">
            <br>
            <h3>{{ $t("posts.descriptionTitle") }}</h3>
            <div style="width: 100%" class="surligneTitre">
                <span v-html="post.texte" style="white-space: pre-wrap;">
                </span>
            </div>
            <br>
        </div>

        <div>
            <br>
            <h3>{{ $t("posts.offerDescription") }}</h3>
            <div style="width: 100%" class="surligneTitre">
                <el-col :span="6" v-if="post.typeOffreLibelle">{{ $t("posts.offerType") }} :</el-col>
                <el-col :span="6" v-if="post.typeOffreLibelle">{{post.typeOffreLibelle}}</el-col>
                <el-col :span="6" v-if="post.typeBienLibelle">{{ $t("posts.propertyType") }} :</el-col>
                <el-col :span="6" v-if="post.typeBienLibelle">{{post.typeBienLibelle}}</el-col>
                <el-col :span="6" v-if="post.prix_hors_taxe">{{ $t("posts.priceWithoutTaxes") }} :</el-col>
                <el-col :span="6" v-if="post.prix_hors_taxe">{{post.prix_hors_taxe}}  {{ post.devise_iso_4217 }}</el-col>
                <el-col :span="6" v-if="post.prix_terrain">{{ $labels.prix_terrain }} :</el-col>
                <el-col :span="6" v-if="post.prix_terrain">{{post.prix_terrain}}  {{ post.devise_iso_4217 }}</el-col>
                <el-col :span="6" v-if="post.frais_annexes">{{ $t("posts.ancillaryCosts") }} :</el-col>
                <el-col :span="6" v-if="post.frais_annexes">{{post.frais_annexes}}  {{ post.devise_iso_4217 }}</el-col>
                <el-col :span="6" v-if="post.loyer_mensuel_cc">{{ $t("posts.view.monthlyRentChargesIncluded") }} :</el-col>
                <el-col :span="6" v-if="post.loyer_mensuel_cc">{{ post.loyer_mensuel_cc }}  {{ post.devise_iso_4217 }}</el-col>
                <el-col :span="6" v-if="post.date_disponibilite">{{ $labels.date_disponibilite }} :</el-col>
                <el-col :span="6" v-if="post.date_disponibilite">{{post.date_disponibilite}}</el-col>
                <el-col :span="6" v-if="post.taxe_fonciere">{{ $labels.taxe_fonciere }} :</el-col>
                <el-col :span="6" v-if="post.taxe_fonciere">{{post.taxe_fonciere}}  {{ post.devise_iso_4217 }}</el-col>
                <el-col :span="6" v-if="post.honoraires_payeurs">{{ $labels.honoraires_payeurs }} :</el-col>
                <el-col :span="6" v-if="post.honoraires_payeurs">{{ post.honoraires_payeurs }}</el-col>
                <el-col :span="6" v-if="post.honoraires_negociation">{{ $labels.honoraires_negociation }} :</el-col>
                <el-col :span="6" v-if="post.honoraires_negociation">{{ post.honoraires_negociation }} {{ post.devise_iso_4217 }}</el-col>
                <el-col :span="6" v-if="post.alur_pourcentage_honoraires_ttc">{{ $labels.alur_pourcentage_honoraires_ttc }} :</el-col>
                <el-col :span="6" v-if="post.alur_pourcentage_honoraires_ttc">{{ post.alur_pourcentage_honoraires_ttc }} %</el-col>
                <el-col :span="6" v-if="post.prestige">{{ $labels.prestige }} :</el-col>
                <el-col :span="6" v-if="post.prestige">{{displayBoolean(post.prestige)}}</el-col>
                <el-col :span="6" v-if="post.viager_vente_a_terme">{{ $labels.viager_vente_a_terme }} :</el-col>
                <el-col :span="6" v-if="post.viager_vente_a_terme">{{displayBoolean(post.viager_vente_a_terme)}}</el-col>
            </div>
            <br><br>
        </div>
        <!--FIN Description-->

      <div v-if="post.visite_virtuelle">
        <br>
        <h3>{{ $labels.visite_virtuelle }}</h3>
        <div style="width: 100%" class="surligneTitre">
          <el-col :span="6" v-if="post.visite_virtuelle">{{ $labels.visite_virtuelle }} :</el-col>
          <el-col :span="18" v-if="post.visite_virtuelle"><a :href="post.visite_virtuelle" style="color: #212529;" target="_blank">{{ $t('lostPassword.backToLoginLink')}}</a></el-col>
        </div>
        <br><br>
      </div>
        <!-- PROMOTEUR PROGRAMME-->
        <div v-if="(isPromoteur && !filter.annonceParente) || isCmiste">
            <!-- Lots -->
            <div v-if="post.annoncesFilles">
                <h3>{{post.annoncesFilles.length}} lot(s)</h3>
                <div style="width: 100%" class="surligneTitre">
                    <ul id="lots">
                        <li v-for="annonceFille in post.annoncesFilles" :key="annonceFille.id">
                            <router-link router-link :to="{ name: 'post-view', params: { post: annonceFille.id } }">
                                {{annonceFille.titre }} ({{annonceFille.reference}})
                            </router-link>

                        </li>
                    </ul>
                </div>
                <br>
            </div>

            <!-- Bon plans-->
            <div v-if="post.offre_titre || post.offre_texte || post.offre_mentions_legales || post.offre_type || post.offre_date_de_debut || post.offre_date_de_fin">

                <h3>{{ $t("posts.offerTitle") }}</h3>
                <div style="width: 100%" class="surligneTitre">
                    <span v-if="post.offre_titre">{{post.offre_titre}}<br></span>
                    <span v-if="post.offre_texte">{{post.offre_texte}}<br></span>
                    <span v-if="post.offre_mentions_legales">{{post.offre_mentions_legales}}<br></span>
                    <span v-if="post.offre_type">{{post.offre_type}}<br></span>
                    <span v-if="post.offre_date_de_debut">{{$labels.offre_date_de_debut}} : {{post.offre_date_de_debut}}<br></span>
                    <span v-if="post.offre_date_de_fin">{{$labels.offre_date_de_fin}} : {{post.offre_date_de_fin}}<br></span>
                </div>
                <br><br>
            </div>

            <!-- Avantages investissements -->
            <div v-if="post.defisc_loi_pinel || post.defisc_loi_duflot || post.defisc_loi_censi_bouvard || post.defisc_loi_girardin_paul || post.defisc_loi_malraux || post.defisc_loi_demessine
                    || post.defisc_regime_scpi || post.defisc_nue_propriete_demembrement || post.pret_locatif_social || post.compatible_psla || post.defisc_loi_mh || post.compatible_ptz_plus || post.defisc_tva_5_virgule_5_pourcent
                    || post.defisc_tva_7_pourcent || post.accession_maitrisee || post.accession_libre || post.bail_reel_solidaire || post.habitat_participatif || post.organisme_foncier_solidaire || post.taux_tva">

                <h3>{{ $t("posts.defiscTitle") }}</h3>
                <div style="width: 100%" class="surligneTitre">
                    <el-col :span="6" v-if="post.defisc_loi_pinel">{{ $labels.defisc_loi_pinel }} :
                        {{displayBoolean(post.defisc_loi_pinel)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_loi_duflot">{{ $labels.defisc_loi_duflot }} :
                        {{displayBoolean(post.defisc_loi_duflot)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_loi_censi_bouvard">{{ $labels.defisc_loi_censi_bouvard
                        }} :
                        {{displayBoolean(post.defisc_loi_censi_bouvard)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_statut_lmp">{{ $labels.defisc_statut_lmp }} : {{ displayBoolean(post.defisc_statut_lmp) }}</el-col>
                    <el-col :span="6" v-if="post.defisc_statut_lmnp">{{ $labels.defisc_statut_lmnp }} : {{ displayBoolean(post.defisc_statut_lmnp) }}</el-col>
                    <el-col :span="6" v-if="post.defisc_loi_girardin_paul">{{ $labels.defisc_loi_girardin_paul }} :
                        {{displayBoolean(post.defisc_loi_girardin_paul)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_loi_malraux">{{ $labels.defisc_loi_malraux }} :
                        {{displayBoolean(post.defisc_loi_malraux)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_loi_demessine">{{ $labels.defisc_loi_demessine }} :
                        {{displayBoolean(post.defisc_loi_demessine)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_regime_scpi">{{ $labels.defisc_regime_scpi }} :
                        {{displayBoolean(post.defisc_regime_scpi)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_nue_propriete_demembrement">{{
                        $labels.defisc_nue_propriete_demembrement }} :
                        {{displayBoolean(post.defisc_nue_propriete_demembrement)}}
                    </el-col>
                    <el-col :span="6" v-if="post.pret_locatif_social">{{ $labels.pret_locatif_social }} :
                        {{displayBoolean(post.pret_locatif_social)}}
                    </el-col>
                    <el-col :span="6" v-if="post.compatible_psla">{{ $labels.compatible_psla }} :
                        {{displayBoolean(post.compatible_psla)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_loi_mh">{{ $labels.defisc_loi_mh }} :
                        {{displayBoolean(post.defisc_loi_mh)}}
                    </el-col>
                    <el-col :span="6" v-if="post.compatible_ptz_plus">{{ $labels.compatible_ptz_plus }} :
                        {{displayBoolean(post.compatible_ptz_plus)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_tva_5_virgule_5_pourcent">{{
                        $labels.defisc_tva_5_virgule_5_pourcent }} :
                        {{displayBoolean(post.defisc_tva_5_virgule_5_pourcent)}}
                    </el-col>
                    <el-col :span="6" v-if="post.defisc_tva_7_pourcent">{{ $labels.defisc_tva_7_pourcent }} :
                        {{displayBoolean(post.defisc_tva_7_pourcent)}}
                    </el-col>
                    <el-col :span="6" v-if="post.accession_maitrisee">{{ $labels.accession_maitrisee }} :
                        {{displayBoolean(post.accession_maitrisee)}}
                    </el-col>
                    <el-col :span="6" v-if="post.accession_libre">{{$labels.accession_libre}} :
                        {{displayBoolean(post.accession_libre)}}
                    </el-col>
                    <el-col :span="6" v-if="post.bail_reel_solidaire">{{ $labels.bail_reel_solidaire }} :
                        {{displayBoolean(post.bail_reel_solidaire)}}
                    </el-col>
                    <el-col :span="6" v-if="post.habitat_participatif">{{ $labels.habitat_participatif }} :
                        {{displayBoolean(post.habitat_participatif)}}
                    </el-col>
                    <el-col :span="6" v-if="post.organisme_foncier_solidaire">{{
                        $labels.organisme_foncier_solidaire
                        }} : {{post.organisme_foncier_solidaire}}
                    </el-col>
                    <el-col :span="6" v-if="post.taux_tva == 5.5">{{ $t("posts.edit.beneficieTVA5") }} : Oui
                    </el-col>
                    <el-col :span="6" v-if="post.taux_tva == 7">{{ $t("posts.edit.beneficieTVA7") }} : Oui</el-col>
                </div>
                <br><br>
            </div>

            <!--  Certifications et labels  -->
            <div v-if="post.label_hqe || post.label_nf_maison_individuelle || post.label_he || post.label_thpe || post.label_hpe_enr || post.label_bbc || post.label_he_effinergie || post.rt_2012 || post.plan_local_habitat || post.re_2020 || post.re_2025 || post.label_biodivercity || post.label_biosource_niveau_1 || post.label_biosource_niveau_2 || post.re_seuil_2028">

                <h3>{{ $t("posts.certificationsAndLabelsTitle") }}</h3>
                <div style="width: 100%" class="surligneTitre">
                    <el-row :gutter="20">
                        <el-col :span="8"><span v-if="post.label_hqe">{{ $labels.label_hqe }}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_nf_maison_individuelle">{{$labels.label_nf_maison_individuelle}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_he">{{$labels.label_he}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_thpe">{{$labels.label_thpe}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_hpe_enr">{{$labels.label_hpe_enr}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_qualibat">{{$labels.label_qualibat}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_acermi">{{ $labels.label_acermi }}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_ce">{{ $labels.label_ce }}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_promotelec">{{$labels.label_promotelec}}</span>
                        </el-col>
                        <el-col :span="8"><span
                                v-if="post.label_maison_de_qualite">{{$labels.label_maison_de_qualite}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_maison_de_confiance">{{$labels.label_maison_de_confiance}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_bbc">{{$labels.label_bbc}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_he_effinergie">{{$labels.label_he_effinergie}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.re_2020">{{$labels.re_2020}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.re_2025">{{$labels.re_2025}}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.plan_local_habitat">{{ $labels.plan_local_habitat }}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_biodivercity">{{ $labels.label_biodivercity }}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_biosource_niveau_1">{{ $labels.label_biosource_niveau_1 }}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.label_biosource_niveau_2">{{ $labels.label_biosource_niveau_2 }}</span>
                        </el-col>
                        <el-col :span="8"><span v-if="post.re_seuil_2028">{{ $labels.re_seuil_2028 }}</span>
                        </el-col>
                    </el-row>
                </div>
                <br>
            </div>

        </div>
        <!--DEBUT Description du bien-->
        <div
                v-if="post.nb_pieces_logement || post.surface_habitable || post.surface_terrain || post.surface_activite ||
                        post.longueur_terrain || post.largeur_terrain || post.lotissement ||
                        (post.constructible && post.typeObjet != 5200) || post.surface_carrez || post.nombre_de_chambres ||
                        post.nb_salles_de_bain || post.nb_salles_d_eau ||  post.nb_wc ||
                        post.wc_independant || post.sejour || post.surface_sejour ||
                        post.salle_a_manger || post.surface_salle_a_manger || post.type_de_cuisine ||
                        post.degagement || post.coin_bureau || post.dressing ||
                        post.buanderie || post.eau_chaude_distribution || post.possede_cajibi ||
                        post.chauffage_energie || post.chauffage_type || post.poele_a_bois ||
                        post.vitrages || post.volets_roulants_electriques || post.duplex ||
                        post.etage || post.nombre_etage || post.ascenseur || post.terrasse ||
                        post.terrasse_surface || post.balcon || post.nb_balcons || post.surface_balcon ||
                        post.loggia || post.garage || post.nb_garages || post.possede_parking ||
                        post.nb_parkings || post.type_stationnement || post.possede_box ||
                        post.cave || post.surface_cave || post.avec_jardin ||  post.surface_jardin ||
                        post.type_jardin || post.grenier || post.avec_toit_terrasse || post.cable_tv ||
                        post.climatise || post.cheminee || post.placards_integres || post.revetement_sol_principal ||
                        post.digicode || post.interphone || post.videophone || post.alarme_habitation ||
                        post.gardien || post.piscine ||post.acces_internet_haut_debit || post.nombre_stationnement ||
                        post.surface_stationnement || post.ca || post.ebe || post.surface_divisible || post.surface_divisible_minimum"
        >
            <br>
            <h3>{{ $t("posts.propertyDescriptionTitle") }}</h3>
            <div style="width: 100%" class="surligneTitre">
                <el-row :gutter="20">
                    <el-col :span="8" v-if="post.constructible && post.typeObjet != 5200" >{{$labels.constructible}}</el-col>

                    <el-col :span="8" v-if="post.wc_independant">{{$labels.wc_independant}}</el-col>

                    <el-col :span="8" v-if="post.sejour">{{$labels.sejour}}</el-col>

                    <el-col :span="8" v-if="post.salle_a_manger">{{$labels.salle_a_manger}}</el-col>

                    <el-col :span="8" v-if="post.degagement">{{$labels.degagement}}</el-col>

                    <el-col :span="8" v-if="post.coin_bureau">{{$labels.coin_bureau}}</el-col>

                    <el-col :span="8" v-if="post.dressing">{{$labels.dressing}}</el-col>

                    <el-col :span="8" v-if="post.buanderie">{{$labels.buanderie}}</el-col>

                    <el-col :span="8" v-if="post.possede_cajibi">{{$labels.possede_cajibi}}</el-col>

                    <el-col :span="8" v-if="post.poele_a_bois">{{$labels.poele_a_bois}}</el-col>

                    <el-col :span="8" v-if="post.volets_roulants_electriques"> {{$labels.volets_roulants_electriques}}</el-col>

                    <el-col :span="8" v-if="post.duplex">{{$labels.duplex}}</el-col>

                    <el-col :span="8" v-if="post.ascenseur">{{$labels.ascenseur}}</el-col>

                    <el-col :span="8" v-if="post.terrasse">{{$labels.terrasse}}</el-col>

                    <el-col :span="8" v-if="post.balcon">{{$labels.balcon}}</el-col>

                    <el-col :span="8" v-if="post.loggia">{{$labels.loggia}}</el-col>

                    <el-col :span="8" v-if="post.garage">{{$labels.garage}}</el-col>

                    <el-col :span="8" v-if="post.possede_parking">{{$labels.possede_parking}}</el-col>

                    <el-col :span="8" v-if="post.possede_box">{{$labels.possede_box}}</el-col>

                    <el-col :span="8" v-if="post.cave">{{$labels.cave}}</el-col>

                    <el-col :span="8" v-if="post.avec_jardin">{{$labels.avec_jardin}}</el-col>

                    <el-col :span="8" v-if="post.avec_toit_terrasse">{{$labels.avec_toit_terrasse}}</el-col>

                    <el-col :span="8" v-if="post.cable_tv">{{$labels.cable_tv}}</el-col>

                    <el-col :span="8" v-if="post.climatise">{{$labels.climatise}}</el-col>

                    <el-col :span="8" v-if="post.cheminee">{{$labels.cheminee}}</el-col>

                    <el-col :span="8" v-if="post.placards_integres">{{$labels.placards_integres}}</el-col>

                    <el-col :span="8" v-if="post.digicode">{{$labels.digicode}}</el-col>

                    <el-col :span="8" v-if="post.interphone">{{$labels.interphone}}</el-col>

                    <el-col :span="8" v-if="post.videophone">{{$labels.videophone}}</el-col>

                    <el-col :span="8" v-if="post.alarme_habitation">{{$labels.alarme_habitation}}</el-col>

                    <el-col :span="8" v-if="post.gardien">{{$labels.gardien}}</el-col>

                    <el-col :span="8" v-if="post.piscine">{{$labels.piscine}}</el-col>

                    <el-col :span="8" v-if="post.acces_internet_haut_debit">{{$labels.acces_internet_haut_debit}}</el-col>

                    <el-col :span="8" v-if="post.surface_divisible">{{$labels.surface_divisible}}</el-col>

                </el-row>
                <br/>
                <el-row :gutter="20">
                    <el-col :span="6" v-if="post.nb_pieces_logement">{{$labels.nb_pieces_logement}} :</el-col>
                    <el-col :span="6" v-if="post.nb_pieces_logement">{{post.nb_pieces_logement}}</el-col>

                    <el-col :span="6" v-if="post.surface_habitable">{{$labels.surface_habitable}} :</el-col>
                    <el-col :span="6" v-if="post.surface_habitable">{{post.surface_habitable}} m²</el-col>

                  <el-col :span="6" v-if="post.surface_activite">{{$labels.surface_activite}} :</el-col>
                  <el-col :span="6" v-if="post.surface_activite">{{post.surface_activite}} m²</el-col>

                    <el-col :span="6" v-if="post.surface_utile">{{$labels.surface_utile}} :</el-col>
                    <el-col :span="6" v-if="post.surface_utile">{{post.surface_utile}} m²</el-col>

                    <el-col :span="6" v-if="post.surface_terrain">{{$labels.surface_terrain}} :</el-col>
                    <el-col :span="6" v-if="post.surface_terrain">{{post.surface_terrain}} m²</el-col>

                    <el-col :span="6" v-if="post.longueur_terrain">{{$labels.longueur_terrain}} :</el-col>
                    <el-col :span="6" v-if="post.longueur_terrain">{{post.longueur_terrain}} M</el-col>

                    <el-col :span="6" v-if="post.largeur_terrain">{{$labels.largeur_terrain}} :</el-col>
                    <el-col :span="6" v-if="post.largeur_terrain">{{post.largeur_terrain}} M</el-col>

                    <el-col :span="6" v-if="post.lotissement">{{$labels.lotissement}} :</el-col>
                    <el-col :span="6" v-if="post.lotissement">{{post.lotissement}}</el-col>

                    <el-col :span="6" v-if="post.surface_carrez">{{$labels.surface_carrez}} :</el-col>
                    <el-col :span="6" v-if="post.surface_carrez">{{post.surface_carrez}} m²</el-col>

                    <el-col :span="6" v-if="post.facade_construction_max">{{$labels.facade_construction_max}} :
                    </el-col>
                    <el-col :span="6" v-if="post.facade_construction_max">{{post.facade_construction_max}} M
                    </el-col>

                    <el-col :span="6" v-if="post.surface_sejour">{{$labels.surface_sejour}} :</el-col>
                    <el-col :span="6" v-if="post.surface_sejour">{{post.surface_sejour}} m²</el-col>

                    <el-col :span="6" v-if="post.hauteur_maximum">{{$labels.hauteur_maximum}} :</el-col>
                    <el-col :span="6" v-if="post.hauteur_maximum">{{post.hauteur_maximum}} M</el-col>

                    <el-col :span="6" v-if="post.modele_maison">{{$labels.modele_maison}} :</el-col>
                    <el-col :span="6" v-if="post.modele_maison">{{post.modele_maison}}</el-col>

                    <el-col :span="6" v-if="post.marque_maison">{{$labels.marque_maison}} :</el-col>
                    <el-col :span="6" v-if="post.marque_maison">{{post.marque_maison}}</el-col>

                    <el-col :span="6" v-if="post.gamme_modele_maison">{{$labels.gamme_modele_maison}} :</el-col>
                    <el-col :span="6" v-if="post.gamme_modele_maison">{{post.gamme_modele_maison}}</el-col>

                    <el-col :span="6" v-if="post.style_construction">{{$labels.style_construction}} :</el-col>
                    <el-col :span="6" v-if="post.style_construction">{{post.style_construction}}</el-col>

                    <el-col :span="6" v-if="post.typeConstruction">{{$labels.type_construction}} :</el-col>
                    <el-col :span="6" v-if="post.typeConstruction">{{post.typeConstruction}}</el-col>

                    <el-col :span="6" v-if="post.type_livraison">{{$labels.type_livraison}} :</el-col>
                    <el-col :span="6" v-if="post.type_livraison">{{post.type_livraison}}</el-col>

                    <el-col :span="6" v-if="post.nombre_de_chambres">{{$labels.nombre_de_chambres}} :</el-col>
                    <el-col :span="6" v-if="post.nombre_de_chambres">{{post.nombre_de_chambres}}</el-col>

                    <el-col :span="6" v-if="post.nb_salles_de_bain">{{$labels.nb_salles_de_bain}} :</el-col>
                    <el-col :span="6" v-if="post.nb_salles_de_bain">{{post.nb_salles_de_bain}}</el-col>

                    <el-col :span="6" v-if="post.nb_salles_d_eau">{{$labels.nb_salles_d_eau}} :</el-col>
                    <el-col :span="6" v-if="post.nb_salles_d_eau">{{post.nb_salles_d_eau}}</el-col>

                    <el-col :span="6" v-if="post.nb_wc">{{$labels.nb_wc}} :</el-col>
                    <el-col :span="6" v-if="post.nb_wc">{{post.nb_wc}}</el-col>

                    <el-col :span="6" v-if="post.surface_salle_a_manger">{{$labels.surface_salle_a_manger}} :
                    </el-col>
                    <el-col :span="6" v-if="post.surface_salle_a_manger">{{post.surface_salle_a_manger}} m²
                    </el-col>

                    <el-col :span="6" v-if="post.type_de_cuisine">Type de cuisine :</el-col>
                    <el-col :span="6" v-if="post.type_de_cuisine">{{post.type_de_cuisine}}</el-col>

                    <el-col :span="6" v-if="post.eau_chaude_distribution">{{$labels.eau_chaude_distribution}} :
                    </el-col>
                    <el-col :span="6" v-if="post.eau_chaude_distribution">{{post.eau_chaude_distribution}}</el-col>

                    <el-col :span="6" v-if="post.chauffage_energie">{{$labels.chauffage_energie}} :</el-col>
                    <el-col :span="6" v-if="post.chauffage_energie">{{post.chauffage_energie}}</el-col>

                    <el-col :span="6" v-if="post.chauffage_type">Nature du chauffage :</el-col>
                    <el-col :span="6" v-if="post.chauffage_type">{{post.chauffage_type}}</el-col>

                    <el-col :span="6" v-if="post.vitrages">{{$labels.vitrages}} :</el-col>
                    <el-col :span="6" v-if="post.vitrages">{{post.vitrages}}</el-col>

                    <el-col :span="6" v-if="post.nombre_niveaux">{{$labels.nombre_niveaux}} :</el-col>
                    <el-col :span="6" v-if="post.nombre_niveaux">{{post.nombre_niveaux}}</el-col>

                    <el-col :span="6" v-if="post.etage">{{$labels.etage}} :</el-col>
                    <el-col :span="6" v-if="post.etage">{{post.etage}}</el-col>

                    <el-col :span="6" v-if="post.nombre_etages">{{$labels.nombre_etages}} :</el-col>
                    <el-col :span="6" v-if="post.nombre_etages">{{post.nombre_etages}}</el-col>

                    <el-col :span="6" v-if="post.terrasse_surface">{{$labels.terrasse_surface}} :</el-col>
                    <el-col :span="6" v-if="post.terrasse_surface">{{post.terrasse_surface}} m²</el-col>

                    <el-col :span="6" v-if="post.nb_balcons">{{$labels.nb_balcons}} :</el-col>
                    <el-col :span="6" v-if="post.nb_balcons">{{post.nb_balcons}}</el-col>

                    <el-col :span="6" v-if="post.surface_balcon">{{$labels.surface_balcon}} :</el-col>
                    <el-col :span="6" v-if="post.surface_balcon">{{post.surface_balcon}} m²</el-col>

                    <el-col :span="6" v-if="post.nb_garages">{{$labels.nb_garages}} :</el-col>
                    <el-col :span="6" v-if="post.nb_garages">{{post.nb_garages}}</el-col>

                    <el-col :span="6" v-if="post.nb_parkings">{{$labels.nb_parkings}} :</el-col>
                    <el-col :span="6" v-if="post.nb_parkings">{{post.nb_parkings}}</el-col>

                    <el-col :span="6" v-if="post.type_stationnement">{{$labels.type_stationnement}} :</el-col>
                    <el-col :span="6" v-if="post.type_stationnement">{{post.type_stationnement}}</el-col>

                    <el-col :span="6" v-if="post.surface_cave">{{$labels.surface_cave}} :</el-col>
                    <el-col :span="6" v-if="post.surface_cave">{{post.surface_cave}} m²</el-col>

                    <el-col :span="6" v-if="post.surface_jardin">{{$labels.surface_jardin}} :</el-col>
                    <el-col :span="6" v-if="post.surface_jardin">{{post.surface_jardin}} m²</el-col>

                    <el-col :span="6" v-if="post.type_jardin">{{$labels.type_jardin}} :</el-col>
                    <el-col :span="6" v-if="post.type_jardin">{{post.type_jardin}}</el-col>

                    <el-col :span="6" v-if="post.grenier">{{$labels.grenier}} :</el-col>
                    <el-col :span="6" v-if="post.grenier">{{post.grenier}}</el-col>

                    <el-col :span="6" v-if="post.mitoyennete">{{$labels.mitoyennete}} :</el-col>
                    <el-col :span="6" v-if="post.mitoyennete">{{post.mitoyennete}}</el-col>

                    <el-col :span="6" v-if="post.revetement_sol_principal">{{$labels.revetement_sol_principal}}
                        :
                    </el-col>
                    <el-col :span="6" v-if="post.revetement_sol_principal">{{post.revetement_sol_principal}}
                    </el-col>

                    <el-col :span="6" v-if="post.nombre_stationnement">{{$labels.nombre_stationnement}} :</el-col>
                    <el-col :span="6" v-if="post.nombre_stationnement">{{post.nombre_stationnement}}</el-col>

                    <el-col :span="6" v-if="post.surface_stationnement">{{$labels.surface_stationnement}} :
                    </el-col>
                    <el-col :span="6" v-if="post.surface_stationnement">{{post.surface_stationnement}} m²</el-col>

                    <el-col :span="6" v-if="post.ca">{{$labels.ca}} :</el-col>
                    <el-col :span="6" v-if="post.ca">{{post.ca}}  {{ post.devise_iso_4217 }}</el-col>

                    <el-col :span="6" v-if="post.ebe">{{$labels.ebe}} :</el-col>
                    <el-col :span="6" v-if="post.ebe">{{post.ebe}}  {{ post.devise_iso_4217 }}</el-col>

                    <el-col :span="6" v-if="post.surface_divisible_minimum">
                        {{$labels.surface_divisible_minimum}} :
                    </el-col>
                    <el-col :span="6" v-if="post.surface_divisible_minimum">{{post.surface_divisible_minimum}}
                        m²
                    </el-col>
                </el-row>
            </div>
            <br>
        </div>
        <div class="sautDeLigneAffiche"></div>
        <!--FIN Description du bien-->
        <!--DEBUT Environnement-->
        <div v-if="post.exposition || post.environnement || post.belle_vue || post.standing ||
                        post.vue_sur_mer || post.est_calme || post.avec_vis_a_vis || post.proche_bus ||
                        post.proche_tram || post.proche_metro || post.proche_gare || post.proche_commerces ||
                        post.ecoles_a_proximitees || post.proche_creche || post.espaces_verts">
            <br>
            <h3>{{ $t("posts.environmentTitle") }}</h3>
            <div style="width: 100%" class="surligneTitre">
                <el-row :gutter="20">
                    <el-col :span="8" v-if="post.belle_vue">{{$labels.belle_vue}} </el-col>

                    <el-col :span="8" v-if="post.vue_sur_mer">{{$labels.vue_sur_mer}} </el-col>

                    <el-col :span="8" v-if="post.est_calme">{{ $labels.est_calme }} </el-col>

                    <el-col :span="8" v-if="post.avec_vis_a_vis">{{ $labels.avec_vis_a_vis }} </el-col>

                    <el-col :span="8" v-if="post.proche_bus">{{ $labels.proche_bus }} </el-col>

                    <el-col :span="8" v-if="post.proche_tram">{{ $labels.proche_tram }} </el-col>

                    <el-col :span="8" v-if="post.proche_metro">{{ $labels.proche_metro }} </el-col>

                    <el-col :span="8" v-if="post.proche_gare">{{ $labels.proche_gare }} </el-col>

                    <el-col :span="8" v-if="post.proche_commerces">{{ $labels.proche_commerces }} </el-col>

                    <el-col :span="8" v-if="post.ecoles_a_proximitees">{{ $labels.ecoles_a_proximitees }} </el-col>

                    <el-col :span="8" v-if="post.proche_ecole_primaire">{{ $labels.proche_ecole_primaire }} </el-col>

                    <el-col :span="8" v-if="post.proche_creche">{{ $labels.proche_creche }} </el-col>

                    <el-col :span="8" v-if="post.espaces_verts">{{ $labels.espaces_verts }} </el-col>
                </el-row>
                <br/>
                <el-row :gutter="20">
                    <el-col :span="6" v-if="post.exposition">{{$labels.exposition}} :</el-col>
                    <el-col :span="6" v-if="post.exposition">{{post.exposition}}</el-col>

                    <el-col :span="6" v-if="post.environnement">{{$labels.environnement}} :</el-col>
                    <el-col :span="6" v-if="post.environnement">{{post.environnement}}</el-col>

                    <el-col :span="6" v-if="post.standing">{{$labels.standing}} :</el-col>
                    <el-col :span="6" v-if="post.standing">{{post.standing}}</el-col>

                </el-row>
            </div>
            <br>
        </div>
        <!--FIN Environnement-->
        <!--DEBUT Etat du bien-->
        <div v-if="post.annee_construction || post.recent || post.meuble || post.annee_renovation">
            <h3>{{ $t("posts.propertyConditionTitle") }}</h3>
            <div style="width: 100%" class="surligneTitre">
                <el-row :gutter="20">
                    <el-col :span="8" v-if="post.recent">{{$labels.recent}}</el-col>

                    <el-col :span="8" v-if="post.meuble === 'oui'">{{$labels.meuble}}</el-col>
                </el-row>
                <br/>
                <el-row :gutter="20">
                    <el-col :span="6" v-if="post.annee_construction">{{$labels.annee_construction}} :</el-col>
                    <el-col :span="6" v-if="post.annee_construction">{{post.annee_construction}}</el-col>

                    <el-col :span="6" v-if="post.annee_renovation">{{$labels.annee_renovation}} :</el-col>
                    <el-col :span="6" v-if="post.annee_renovation">{{post.annee_renovation}}</el-col>
                </el-row>
            </div>
        </div>
        <!--FIN Etat du bien-->
        <!--DEBUT Copropriété-->
        <CoProprieteInfo :post="post" />
        <!--FIN Copropriété-->

        <!-- DEBUT PARTENAIRE FONCIER -->
        <div v-if="post.partenaire_foncier_societe || post.partenaire_foncier_nom ||
                 post.partenaire_foncier_prenom || post.partenaire_foncier_telephone">
            <br>
            <h3>{{ $t("posts.propertyPartnerTitle") }}</h3>
            <div style="width: 100%" class="surligneTitre">
                <el-col :span="6" v-if="post.partenaire_foncier_societe">{{
                    $t("posts.edit.propertyPartnerCompany")
                    }} :
                </el-col>
                <el-col :span="6" v-if="post.partenaire_foncier_societe">{{post.partenaire_foncier_societe}}
                </el-col>
                <el-col :span="6" v-if="post.partenaire_foncier_nom">{{ $t("posts.edit.propertyPartnerLastname")
                    }}
                    :
                </el-col>
                <el-col :span="6" v-if="post.partenaire_foncier_nom">{{post.partenaire_foncier_nom}}</el-col>
                <el-col :span="6" v-if="post.partenaire_foncier_prenom">{{
                    $t("posts.edit.propertyPartnerFirstname")
                    }} :
                </el-col>
                <el-col :span="6" v-if="post.partenaire_foncier_prenom">{{post.partenaire_foncier_prenom}}</el-col>
                <el-col :span="6" v-if="post.partenaire_foncier_telephone">{{
                    $t("posts.edit.propertyPartnerPhone")
                    }} :
                </el-col>
                <el-col :span="6" v-if="post.partenaire_foncier_telephone">{{post.partenaire_foncier_telephone}}
                </el-col>
            </div>
        </div>
        <!-- FIN PARTENAIRE FONCIER -->
        <!--DEBUT DPE-->
        <div v-if="post.dpe_valeur_conso || post.dpe_etiquette_conso || post.dpe_valeur_ges ||
                    post.dpe_etiquette_ges || post.dpe_vierge">
            <br>
            <h3>{{ $t("posts.dpeTitle") }}</h3>
            <div style="width: 100%" class="surligneTitre">
                <div class="blockDonneesDPE" v-if="post.dpe_valeur_conso">{{$labels.dpe_valeur_conso}} :</div>
                <div class="blockDonneesDPEVal" v-if="post.dpe_valeur_conso">{{post.dpe_valeur_conso}}</div>

                <div class="blockDonneesDPE" v-if="post.dpe_etiquette_conso">{{$labels.dpe_etiquette_conso}} :</div>
                <div class="blockDonneesDPEVal" v-if="post.dpe_etiquette_conso">{{post.dpe_etiquette_conso}}</div>

                <div class="blockDonneesDPE" v-if="post.dpe_valeur_ges">{{$labels.dpe_valeur_ges}} :</div>
                <div class="blockDonneesDPEVal" v-if="post.dpe_valeur_ges">{{post.dpe_valeur_ges}}</div>

                <div class="blockDonneesDPE" v-if="post.dpe_etiquette_ges">{{$labels.dpe_etiquette_ges}} :</div>
                <div class="blockDonneesDPEVal" v-if="post.dpe_etiquette_ges">{{post.dpe_etiquette_ges}}</div>

                <div class="blockDonneesDPE" v-if="post.dpe_vierge != null">{{$labels.dpe_vierge}} :</div>
                <div class="blockDonneesDPEVal" v-if="post.dpe_vierge != null">{{displayBoolean(post.dpe_vierge)}}</div>
            </div>
            <br>
        </div>
        <!--FIN DPE-->
        <!--DEBUT Condition de vente-->
        <div v-if="post.prixDisplay || post.honoraire_charge_acquereur || this.prixDisplay">
            <div class="grid-content bg-purple text-center" id="blockPrix">
                <div v-if="this.prixDisplay">
                  <strong>{{ $t("posts.view.saleConditionsPrice") }} : {{this.prixDisplay}}</strong>
                </div>
                <div v-else>
                  <strong v-if="post.typeOffre !== 'I' && post.typeOffre !== 'L'">{{ $t("posts.view.saleConditionsPrice") }} : {{post.prixDisplay}}</strong>
                  <div v-if="post.typeOffre === 'I'"><strong>{{post.prixDisplay}}</strong></div>
                  <div v-if="post.typeOffre === 'L'"><strong>{{ $t("posts.view.rent") }} : {{post.prixDisplay}}</strong></div>
                  <div v-if="post.prix_terrain">{{ $t("posts.view.saleConditionsLand") }} : {{post.prix_terrain}}  {{ post.devise_iso_4217 }}</div>
                  <div v-if="post.honoraire_charge_acquereur">{{ $t("posts.view.saleConditionsBuyerFee") }} :
                    {{post.honoraire_charge_acquereur}}
                  </div>
                </div>
            </div>
        </div>
        <!--FIN Condition de vente-->
    </div>
</template>

<script>
import { mapState } from 'vuex'
import CoProprieteInfo from '@/pages/posts/View/components/CoProprieteInfo.vue'

export default {
  name: 'PostViewImmo',
  components: { CoProprieteInfo },
  inject: ['browserContext'],
  props: ['post'],
  data () {
    return {
      photoAgrandit: null,
      photoPrincipale: null,
      showModal: false,
      emailDestinataire: null,
      commentaireEmail: this.$t('posts.view.sendByEmailComment'),
      prixDisplay: null
    }
  },
  computed: {
    ...mapState('posts', ['filter']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    pageTitle () {
      if (this.isPromoteur) {
        if (this.filter.annonceParente) {
          return this.$t('posts.view.pageTitleLot')
        } else {
          return this.$t('posts.view.pageTitleProgram')
        }
      }
      return this.$t('posts.view.pageTitleAd')
    },
    results () {
      return this.$store.state.posts.results
    }
  },
  methods: {
    displayBoolean (value) {
      if (value === true) {
        return this.$t('general.yes')
      }
      if (value === false) {
        return this.$t('general.no')
      }
      return value
    },
    handleDisplayPrice () {
      // Gestion affichage prix pour l'espace client
      if (this.post.prixDisplay.indexOf('nous consulter') !== false) {
        if (this.post.loyer_mensuel_cc) {
          this.prixDisplay = this.post.loyer_mensuel_cc + ' ' + this.$t('posts.view.monthlyRentChargesIncludedDisplay')
        }
      }
    }
  },
  beforeMount () {
    this.handleDisplayPrice()
  }
}
</script>

<style>
    .blockDonnees {
        display: inline-block;
        width: 25%;
    }

    .blockDonneesDPE {
        display: inline-block;
        width: 30%;
    }

    .blockDonneesDPEVal {
        display: inline-block;
        width: 20%;
    }

    #blockPrix {
        margin-top: 15px;
        border: solid;
        border-color: #00b4cc;
        border-width: 1px;
        font-size: 30px;
    }

    /*DEBUT VERSION MOBILE*/
    @media screen and (max-width: 780px) {
        .blockDonnees {
            display: inline-block;
            width: 50%;
        }

        .blockDonneesDPE {
            display: inline-block;
            width: 70%;
        }

        .blockDonneesDPEVal {
            display: inline-block;
            width: 30%;
        }
    }

    /*FIN VERSION MOBILE*/

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }
</style>
